import { OpenEndedAnswerType } from '@sm/question-widgets/respondent-survey';
import { QuestionAnswerInput } from '~lib/generatedGqlTypes';

export const mapOpenEndedResponse = (answer: OpenEndedAnswerType): QuestionAnswerInput['openEnded'] => {
  const { family, variant, values } = answer;
  if (family !== 'OPEN_ENDED') return [];

  switch (variant) {
    case 'SINGLE_LINE':
    case 'ESSAY': {
      return [{ textAnswer: values[0].value, fieldSetId: '' }];
    }
    default: {
      return [];
    }
  }
};

export default mapOpenEndedResponse;
